<template>
  <div>
    <ul class="select-detail">
      <li
        @click="methodLinkTo"
        :style="{ height: height, 'line-height': height }"
      >
        <i
          class="iconfont font-44 c-006AFE"
          v-show="isSelect && selected"
          @click="methodSelectItem('add')"
          >&#xe604;</i
        >
        <i
          class="iconfont font-44 radio-unselect"
          v-show="isSelect && !selected"
          @click="methodSelectItem('reduce')"
          >&#xe603;</i
        >
        <div
          class="fb fb-main-start fb-cross-center"
          :class="{ bb: addBottom }"
        >
          <span class="font-34">
            <div>{{ listItem }}</div>
            <slot name="custom"></slot>
          </span>
          <i class="iconfont c-171A1D-32 font-30">&#xe66b;</i>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    isSelect: {
      type: Boolean,
      default: false
    },
    listItem: {
      type: String,
      default: ''
    },
    itemOrder: {
      type: Number,
      default: null
    },
    addBottom: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '48px'
    }
  },
  data() {
    return {
      selected: true
    }
  },
  methods: {
    methodSelectItem(operateMethods) {
      this.selected = !this.selected
      this.$emit('operate')
    },
    methodLinkTo() {
      this.$emit('linkTo')
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.select-detail {
  margin-top: 0px;
  li {
    display: flex;
    background: #fff;
    > i {
      padding: 0 0 0 16px;
      width: 48px;
    }
    > div {
      display: flex;
      justify-content: space-between;
      margin-left: 16px;
      width: 100%;
      > i {
        margin-right: 16px;
      }
    }
  }
}

.radio-unselect {
  color: rgba(25, 31, 37, 0.72);
}
</style>
